import { EpimsBaseEntityDto } from './epim-base.dto';
export class AssetLocationDto extends EpimsBaseEntityDto {
   AssetLocationId: string;
   StateId: string;
   LgaId: string;
   DivisionId: string;
   CommunityId: string;
   AssetLocationAddress: string;
   LandTitleId: string;
}

